export default function () {
  if (document.querySelectorAll('.content-block-section-image').length) {
    import(/* webpackChunkName: "content-blocks" */ './content-blocks')
      .then(module => module.default())
      // eslint-disable-next-line no-unused-vars
      .catch(error => 'An error occurred while loading content-blocks');
  }
}



// WEBPACK FOOTER //
// ./node_modules/cigna-frontend/js/content-blocks/index.js